module.exports = __webpack_public_path__ + "img/logo.1cb077f9.svg";